/**
 * @enum LvfVehicleBrakeType
 *  * @classdesc Represents the supported EquipmentVehicle Brake Type Source.
 */
export enum LvfVehicleBrakeType {

  DISQUE = 1,
  TAMBOUR = 2,
}
